export default __webpack_public_path__ + "static/media/background1.9e433785.png";